const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  searchItemMold4 ({ state, commit, rootState }, params) {
    return rootState.axios.get('/tpsp/v1frontend/tptt-trade/search-item-mold4', { params })
  },
  replicateTradeItem ({ state, commit, rootState }, params) {
    return rootState.axios.post('/tpsp/v1frontend/tptt-trade/replicate-trade-item', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
